import { Box, Grid } from '@mui/material'
import React from 'react'
import GreenBanner from './GreenBanner'
import YellowBanner from './YellowBanner'
import BlueBanner from './BlueBanner'
import Header from '../common/header/Header'

const HeaderComponent =() => {
  return (
    <Grid component={'header'} style={{ backgroundColor:'transparent', padding:'0'}}>
      <Box component={'a'} href="#main-content" className="skip-link" 
        sx={{
          position: "absolute",
          left: "-10000px",
          top: "auto",
          width: "1px",
          height: "1px",
          overflow: "hidden",
          zIndex: 100,
          "&:focus": {
            position: "static",
            width: "auto",
            height: "auto",
            overflow: "visible",
            display: "inline-block",
            margin: "3px",
          },
        }}
      >Skip to main content</Box>
        <GreenBanner />
        <YellowBanner />
        <BlueBanner />
        <Header />
    </Grid>
  )
}

export default HeaderComponent